import React, {useContext} from "react";
import OrganizationContext from "../context/OrganizationContext"

export const useOrganization = () => {
    const organization = useContext(OrganizationContext)
    return organization
}